import { getContractToASDS } from '../../services/adminContracts';
import { postTemplateRequest, updateTemplateRequest } from '../../services/templateServiceRequest';
import { ubicationTypeEnum } from '../../utils/dataStatus';

const fetchContract = async (unidadNegocioId, servicioId, proveedorId, eventoId = null) => {
  const body = {
    proveedorId,
    unidadNegocioId,
    servicioId,
    eventoId
  };
  const response = await getContractToASDS(body);

  return response?.data?.contratos;
};

const approversAdapter = (approvers) =>
  approvers?.map((approver) => ({
    id: approver?.id,
    esGrupo: approver?.esGrupo,
    nombre: approver?.nombre,
    idPlantillaSolicitudServicioProveedor: approver?.idRequestApprover
  }));

const additionalReceiversAdapter = (additionalReceivers) =>
  additionalReceivers?.map((additionalReceiver) => ({
    id: additionalReceiver.id,
    esGrupo: additionalReceiver.esGrupo,
    nombre: additionalReceiver.nombre,
    idSolicitudServicioDestinatario: additionalReceiver?.idRequestAditionalReceivers
  }));

const providersAdapter = async (providers, idService) => {
  const providersToReturn = await Promise.all(
    providers?.map(async (provider) => {
      // The backend requires re-fetching provider data
      // in case it changed when creating the request
      // we obtain the list of contracts associated with the provider
      const contracts = await fetchContract(
        provider.provider?.id ? provider.businessUnit?.id : undefined,
        idService,
        provider.provider?.id
      );

      const selectedContract = contracts.filter(
        (contract) => contract?.id === provider?.contract?.id
      )[0];

      return {
        idContrato: provider?.contract?.id,
        idProveedor: provider.provider?.id,
        idUnidadNegocio: provider.provider?.id ? provider.businessUnit?.id : undefined,
        numeroContrato: Number(provider?.contract?.nombre) || undefined,
        requiereAceptacion: selectedContract?.requiereAceptacion,
        requiereAdjuntos: selectedContract?.requiereAdjuntarArchivo,
        tipoNotificacionEnum: provider?.notificate?.id,
        idPlantillaSolicitudServicioProveedor: provider?.idRequestProvider,
        proveedorNombre: provider?.provider?.nombre
      };
    })
  );

  return providersToReturn;
};

const wellsAdapater = (wells, values) => {
  if (wells?.length) {
    return wells?.map((well) => ({
      idPozo: well?.well?.id || well?.well?.value,
      idEquipo: well?.team?.value,
      tipoImputacionEnum: well?.imputationType?.value,
      idObjetoImputacion: well?.imputationObject?.value,
      idEventoPozo: well?.event?.eventoPozoId,
      idPlantillaSolicitudServicioPozo: well?.idRequestWell
    }));
  }
  if (values?.ubication?.ubicationType?.id === ubicationTypeEnum.pozo) {
    return [
      {
        idPozo: values?.ubication?.ubication?.id
      }
    ];
  }

  return undefined;
};

const attachmentsMapper = (accordionId, templateRequestId, attachments = []) => {
  const attachmentsAccordions = attachments.filter(
    (attachment) =>
      attachment.accordionId.toString() === accordionId.toString() && attachment.serviceRequestId
  );

  return attachmentsAccordions?.map((attachment) => ({
    idPlantillaArchivoAdjuntoSolicitudServicio: templateRequestId,
    nombre: `${templateRequestId}_${attachment?.nombre}`,
    fechaSubida: attachment?.fechaSubida,
    nombreUsuarioSubida: attachment?.usuarioSubida,
    id: attachment?.id || attachment?.nombre,
    peso: attachment?.peso,
    accordionId,
    templateRequestId
  }));
};

const templateRequestAdapter = (values, files) =>
  Promise.all(
    values.accordions.map(async (accordion) => ({
      // The backend cannot identify each accordion
      // when attaching files to it
      // so we send a key to identify it
      id: accordion?.templeteRequestId,
      idEvento: values?.ubication?.event?.id || values.imputationObject?.wells[0]?.event?.id,
      idServicio: accordion.service?.service?.id,
      servicioDescripcion: accordion.service?.description,
      idUnidadNegocio: values?.ubication?.uunn?.id,
      servicioNombre: accordion.service?.service?.nombre,
      estadoEnum: 2,
      tipoUbicacionEnum: values?.ubication?.ubicationType?.id,
      ubicacion: {
        id: values?.ubication?.ubication?.id,
        nombre: values?.ubication?.ubication?.nombre
      },
      eventoNombre:
        values?.ubication?.event?.nombre || values.imputationObject?.wells[0]?.event?.nombre,
      unidadNegocioNombre: values?.ubication?.uunn?.nombre,
      stepEnum: accordion.accordionStep,
      eventoSigla:
        values?.ubication?.event?.sigla || values?.imputationObject?.wells[0]?.event?.sigla,
      plantillaSolicitudServicioDestinatarios: additionalReceiversAdapter([
        // eslint-disable-next-line no-unsafe-optional-chaining
        ...accordion.associatedUsers?.aditionalReceivers
      ]),
      plantillaSolicitudServicioAprobadores: approversAdapter(
        accordion?.associatedUsers?.approvers
      ),
      plantillaSolicitudServicioProveedores: accordion?.provider?.providers[0]?.provider
        ? await providersAdapter(accordion.provider?.providers, accordion.service?.service?.id)
        : undefined,
      plantillaSolicitudServicioPozos: wellsAdapater(values?.imputationObject?.wells),
      plantillaArchivoAdjuntoSolicitudServicio: attachmentsMapper(
        accordion?.accordionId,
        accordion?.templeteRequestId,
        files
      )
    }))
  );

export const generateRequestTemplate = async (values, files, id = null) => {
  if (id) {
    const AdaptedEditedValues = {
      id,
      nombrePlantilla: values.templateName,
      esPublico: values.templateIsPublic,
      plantillaSolicitudServicio: await templateRequestAdapter(values, files)
    };

    return updateTemplateRequest(AdaptedEditedValues);
  }
  const valuesAdapted = {
    nombrePlantilla: values.templateName,
    esPublico: values.templateIsPublic,
    plantillaSolicitudServicio: await templateRequestAdapter(values)
  };

  return postTemplateRequest(valuesAdapted);
};

export default generateRequestTemplate;
